import { ShowMoreItemsInBulkWebComponent } from './component/ShowMoreItemsInBulkWebComponent';

export { ShowMoreItemsInBulkWebComponent };
